/*!
 * Here comes description.
 *
 * @package tokai-univ
 */

/*!
 * @deps jquery
 */

const $ = jQuery;

const execCopy = function ( string ) {
	const tmp = document.createElement( 'div' );
	const pre = document.createElement( 'pre' );
	// If parent elements has `user-select: none`, cannot copy.
	// So let's override this property.
	pre.style.webkitUserSelect = 'auto';
	pre.style.userSelect = 'auto';

	tmp.appendChild( pre ).textContent = string;
	// Mover element outside window.
	const s = tmp.style;
	s.position = 'fixed';
	s.right = '200%';
	// Append to body
	document.body.appendChild( tmp );
	// Select element.
	document.getSelection().selectAllChildren( tmp );
	// Copy to clipboard.
	const result = document.execCommand( 'copy' );
	// Remove parent.
	document.body.removeChild( tmp );
	return result;
};

// Add event listener for click event.
$( '.js-clipboard-button' ).click( function ( e ) {
	e.preventDefault();
	const content = $( this ).val();
	execCopy( content );
} );
